declare namespace $ {

	export class $mol_icon_align_horizontal_center extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=center.view.tree.d.ts.map